export default __webpack_public_path__ + "static/media/Ring of Katar.dc08e75f.jpg";